import { useLocation, useNavigate } from "react-router-dom";
import listening from "./../assets/images/listeningYAS.svg";
import moozik from "./../assets/images/moozik.svg";
import screenShotMultipleFilterBlueTintShort from "./../assets/images/screenShotMultipleFilterBlueTintShortYAS.png";

import Paye from "../components/Paye";
import Header from "../components/Header";
import { useEffect } from "react";

const Payment = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (!state) {
      navigate("/");
    } else if (
      state &&
      (!state.rpid ||
        !state.offername ||
        !state.amount ||
        !state.msisdn ||
        !state.otp)
    ) {
      navigate("/");
    }
  }, [navigate, state]);

  return (
    <div className="bg-whitesmoke-300 min-h-screen flex justify-center">
      <div className="max-w-[641px] w-full bg-[#00377D] h-auto overflow-visible text-left text-base text-white font-montserrat">
        <Header hideMsisdn={false} hideAccount={true}/>
        <div className="relative top-[20px] left-[0px] w-[100%] h-[fit-content] [background:#123274]">
          <img
            className="relative top-[-40px] w-[100%] object-contain"
            alt=""
            src={listening}
          />
          <img
            className="relative top-[0px] w-[100%] object-cover"
            alt=""
            src={screenShotMultipleFilterBlueTintShort}
          />
          <div className="absolute bottom-[10%] left-[5%] right-[5%] w-auto z-5">
            <img
              className="relative w-[102px] h-[102px] object-cover"
              alt=""
              src={moozik}
            />
            <div className="relative text-14xl mt-7 mb-7 leading-[42px] uppercase font-black text-whitesmoke-200">
              <p className="m-0 z-10">{`PAIEMENT `}</p>
            </div>
            <div className="relative z-5 w-auto flex items-center flex-col justify-center">
              {state ? <Paye /> : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
